var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtsy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fa772f",
    d: "M23.181,3,7,3.04a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H9.013a3.005,3.005,0,0,1,3.013,3V38.007a3.005,3.005,0,0,1-3.013,3H7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h33.43a2,2,0,0,0,1.985-1.694l1.569-10.142A1,1,0,0,0,43,32.013H40.954a1,1,0,0,0-.98.782l-1.135,5.08A4.013,4.013,0,0,1,34.917,41H22.07a3.005,3.005,0,0,1-3.013-3V26.019h8.035a4.006,4.006,0,0,1,4.017,4h0a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V17.028a1,1,0,0,0-1-1h-1a1,1,0,0,0-1,1v1a4.006,4.006,0,0,1-4.017,4H19.057V10.035a3.005,3.005,0,0,1,3.013-3H34.122a4.008,4.008,0,0,1,4.018,4v3a1,1,0,0,0,1,1h1.085a1,1,0,0,0,1-.916l.837-9.992a1,1,0,0,0-1-1.082Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtsy);
export default __webpack_public_path__ + "static/media/etsy.38464bc345d80c5a7fd699762bc47bd1.svg";
export { ForwardRef as ReactComponent };